module.exports = __webpack_public_path__ + "img/38.5.COD.1a1886e8.png";